// Reseñas reales de clientes recopiladas de la ficha de Google Business de Club Amistad.
// Fuente: Google Business Profile (perfil verificado).

// URL pública de la ficha de Google Business (aparece en el badge y como enlace).
// CID extraído del rldimm de la búsqueda de Google Local (218605314926554260).
export const GOOGLE_BUSINESS_URL =
  "https://www.google.com/maps?cid=218605314926554260";

// Rating agregado publicado en Google (usado en JSON-LD AggregateRating).
export const GOOGLE_AGGREGATE_RATING = {
  ratingValue: 4.7,
  ratingCount: 100,
  bestRating: 5,
  worstRating: 1,
};

export const TESTIMONIALS = [
  {
    name: "Juan Manuel Lozano Montaño",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Cursos y viajes en familia",
    text:
      "Llevamos ya tres años formando parte del club y la experiencia ha sido positiva. Desde el primer momento hemos encontrado una organización seria, bien estructurada y con un nivel de profesionalidad muy alto. La calidad de las clases de esquí es sobresaliente, perfectamente adaptada al nivel y a la evolución de cada niño. Los profesores son verdaderos educadores y referentes, capaces de transmitir valores fundamentales como el compañerismo, el respeto y el amor por la montaña.",
  },
  {
    name: "Esther Ortega Sánchez",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Masella · Fin de Año",
    text:
      "Espectacular viaje de esquí en La Masella. Hemos estado del 28/12 al 2/1 con una organización perfecta, todo pensado para disfrutar con los niños del esquí y la familia. Los monitores que tuvimos Alberto para mí y Jaime para el pequeño han sido maravillosos. ¡Repetiremos seguro!",
  },
  {
    name: "Macarena Plaza",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Fin de Año",
    text:
      "Sin ningún lugar a dudas los mejores. Un viaje perfecto para familias, los niños lo pasan genial, los mayores también. Es nuestro tercer año y sin duda repetiremos. Hemos venido en Fin de Año y también hacen viajes en Navidad, Reyes, los puentes... Una apuesta segura.",
  },
  {
    name: "Jaime Peñalba",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Masella",
    text:
      "Experiencia 10 sobre 10. Nuestro viaje en Masella inmejorable. Los monitores son increíbles, atentos, cariñosos con los niños. El hotel a pie de pista es un puntazo. El próximo año repito seguro. Muchas gracias al Club Amistad por estos días. Simplemente inolvidable.",
  },
  {
    name: "Ana Aymerich de Franceschi",
    rating: 5,
    date_label: "Hace 6 meses",
    trip: "Masella · Viaje familiar",
    text:
      "Todo fenomenal. Organizaron el viaje de esquí del colegio de mis hijos en Masella, y los profesores un 10 en la parte técnica pero también en la humana. Los niños estaban encantados. Y especial mención a Alberto, profe de adultos, que no pudo organizar unas clases mejores. ¡Mil gracias!",
  },
  {
    name: "Adriana García-Abril",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Viaje familiar",
    text:
      "Super experiencia. Planazo para ir con niños. Todo muy bien organizado y trato super cercano. Las clases con Alberto, buenísimas. ¡Recomendable 100%!",
  },
  {
    name: "Irene García",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Cliente desde hace años",
    text:
      "Llevo toda la vida en este Club. Aprendí a esquiar con ellos en la Sierra de Madrid y después me han ayudado a organizar viajes de esquí todos los años. Son unos increíbles profesionales, desde el personal de administración, los profesores de esquí y los coordinadores de viaje. Lo recomiendo sin duda.",
  },
  {
    name: "Rocío Martínez Vidaurrazaga",
    rating: 5,
    date_label: "Hace 4 meses",
    trip: "Viaje con menores",
    text:
      "Mi hija acaba de venir de un viaje de esquí con ellos y no tengo más que buenas palabras. Los monitores súper profesionales y divertidos, y ella ha vuelto encantada — y eso que no conocía a nadie antes de ir. ¡Repetiremos seguro!",
  },
  {
    name: "Isabel DB",
    rating: 5,
    date_label: "Hace 4 meses",
    trip: "Viaje juvenil",
    text:
      "Dejar a nuestra hija con el Club Amistad ha sido un gran acierto. Ha disfrutado esquiando y son muy profesionales; desde el desayuno hasta que se acuestan está todo controlado.",
  },
  {
    name: "Daniel Moreno",
    rating: 5,
    date_label: "Hace 7 meses",
    trip: "Cursos en Xanadú",
    text:
      "Es el segundo año que mi hijo hace cursos con este club. No puedo estar más encantado con la información, cuidado, preparación y atención de todos los monitores. Alberto es una persona encantadora que siempre busca que las familias estén lo más atendidas posible. Sin duda, el año que viene repetiremos. ¡Bravo por este club!",
  },
];
